import ICommit from '@/store/contracts/commit'

const getDefaultState = () => {
    return {
        user: {},
        selectedCategories: [],
        avatarSelected: null,
        userProfile: null,
        user_logged: false,
        points: 0,
        coins: 0,
        level: 0,
        advancePercent: 0,
        user_loaded: false,
        survey: null,
        survey_answer: {
            surveyId: null,
            userId: null,
            answers: [],
        },
        recievedMessages: [],
        existAssignedBook: false,
        assignedBookId: null,
        remainDays: null,
    }
}

const User = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        userData: (state: any, data: any) => {
            if (data.user) state.user = data.user
            if (data.categories) state.selectedCategories = data.categories
            if (data.userProfile) state.userProfile = data.userProfile
            if (data.avatarSelected) state.avatarSelected = data.avatarSelected
            if (data.gameStats) {
                state.points = data.gameStats.points
                state.coins = data.gameStats.coins
                state.level = data.gameStats.userLevel
                state.advancePercent = data.gameStats.advancePercent
            }
        },
        userGamification: (state: any, data: any) => {
            if (data.id) {
                state.points = data.points
                state.coins = data.coins
                state.level = data.userLevel
                state.advancePercent = data.advancePercent
            }
        },
        logoutUser: (state: any) => {
            state.user = null
            state.user_logged = false
        },
        userLogged: (state: any, value: any) => {
            state.user_logged = value
        },
        avatar: (state: any, value: any) => {
            state.avatarSelected = value
        },
        selectedCategories: (state: any, value: any) => {
            state.selectedCategories = value
        },
        userLoaded: (state: any, value: any) => {
            state.user_loaded = value
        },
        setSurvey: (state: any, value: any) => {
            state.survey = value
        },
    },
    actions: {
        changeCategories({ commit }: ICommit, categories: any) {
            commit('selectedCategories', categories)
        },
        changeAvatar({ commit }: ICommit, selectedAvatar: any) {
            commit('avatar', selectedAvatar)
        },
        setGamification({ commit }: ICommit, gamificationData: any) {
            commit('userGamification', gamificationData)
        },
        setUserData({ commit }: ICommit, userData: any) {
            commit('userData', userData)
        },
        setUserLoaded({ commit }: ICommit, value: any) {
            commit('userLoaded', value)
        },
        setSurvey({ commit }: ICommit, value: any) {
            commit('setSurvey', value)
        },
        setCoins({ state }: any, value: any) {
            state.coins = value
        },
        setPoints({ state }: any, value: any) {
            state.points = value
        },
        setRecievedMessages({ state }: any, value: any) {
            state.recievedMessages = value
        },
        resetUserState({ state }: any) {
            Object.assign(state, getDefaultState())
        },
        setExistAssignedBook({ state }: any, value: any) {
            state.existAssignedBook = value
        },
        setAssignedBookId({ state }: any, value: any) {
            state.assignedBookId = value
        },
        setRemainDays({ state }: any, value: any) {
            state.remainDays = value
        },
    },
    getters: {
        loggedIn: (state: any) => !!state.user,
    },
}

export default User
